/**
 * @fileoverview
 * This file is used to define the supported language codes for the application.
 * It is used in the build script to generate the translation files.
 * It is also used in the React/Typescript code to define the supported languages.
 * If you need to add a new language, make sure to add the standard simplified code here and
 * also add it in the Type definition file (.d.ts).
 */

// -------------------------------------------------------------------------------------------------

/**
 * Supported language codes.
 * When adding a new language, make sure to add the standard simplified code here.
 * Ideally, it should match the ones also supported by the Deepl backend:
 * https://translate-qa.idplans.com/swagger/index.html
 */
const SupportedLanguageCodes = {
    English: 'en-US',
    Spanish: 'es',
    Chinese: 'zh',
    French: 'fr',
    Vietnamese: 'vi',
};

/**
 * The language that the main app will default to.
 * This is the language that will be used if the user's language is not supported or when first loading the app
 * and i18next couldn't automatically select a language.
 */
const MainAppLanguage = SupportedLanguageCodes.English;

/**
 * Keep this file as a simple CommonJS module so that we can use it in the build script!
 * By editing this file alone, we can ensure both the React/Typescript and the build script are in sync.
 * @see build/i18n/config/constants.js
 * @see src/Core/i18n/Config/SupportedLanguages.ts
 */
module.exports = { SupportedLanguageCodes, MainAppLanguage };
